App.prototype.buildOrderInput = function (data, targetElement) {
    var required = data.is_required ? ' required' : '';

    var input = '';
    var options = [];

    if (['checkbox', 'select'].includes(data.type)){
        options = data.option_list.split(',').map((i) => i.trim());
    }

    switch (data.type) {
        case 'text':
            input = `<input type="text" name="order_inputs[${data.unique_id}]" class="form-control" ${required}/>`;
            break;
        case 'textarea':
            input = `<textarea rows="3" name="order_inputs[${data.unique_id}]" class="form-control" ${required}/></textarea>`;
            break;
        case 'checkbox':
            for (let i = 0; i < options.length; i++) {
                input += `<div class="custom-control custom-checkbox">`;
                input += `<input type="checkbox" name="order_inputs[${data.unique_id}][]" id="${data.unique_id}_${i}" class="custom-control-input" value="${options[i]}" />`;
                input += `<label class="custom-control-label" for="${data.unique_id}_${i}">${options[i]}</label>`;
                input += `</div>`;
            }
            break;
        case 'select':
            input = `<select name="order_inputs[${data.unique_id}]" class="form-control" ${required}>`;
            input += '<option value="">' + translates.choose + '</option>';
            for (let i = 0; i < options.length; i++) {
                input += `<option value="${options[i]}">${options[i]}</option>`;
            }
            input += `</select>`;
            break;
        case 'file':
            input = `<input type="file" name="order_inputs[${data.unique_id}]" class="form-control-file" ${required} accept="image/jpeg,image/png,image/webp,application/pdf"/>`;
            input += `<small>${translates.product_order_input.file_rules}</small>`
            break;
    }

    var select = `<div class="form-group"><label>${data.name}</label>${input}</div>`;
    targetElement.append(select);
};
